import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-style9_home",
  "use": "icon-style9_home-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-style9_home\">\n<g>\n\t<polygon points=\"99.2,24.8 14.8,102.9 24.4,113.1 99.2,44 173.1,113.1 182.7,102.9 \t\" />\n\t<polygon points=\"39.1,111 39.1,175.5 78.1,175.5 78.1,140.3 119.8,140.3 119.8,175.4 158.3,175.4 158.3,112.8 98.3,55.9 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol